import { IKey, ISearchPageField, ITableRecordEdit, ITimeRangeType, ITimeRangeVo } from '@/types/FmsTypes'
import {
    AccountLogTypeEnum,
    AccountStatusEnum,
    AdjustStatusEnum,
    CreditFlagEnum,
    UserTypeEnum,
    RechargeStatusEnum,
    TransferStatusEnum,
    TransactStatusEnum,
} from '@/types/FmsEnums'
import { IMdCustomerDetail } from '../base/customer/customerService'
import { IMdSupplierDetail } from '../base/supplier/supplierService'
import React, { Key } from 'react'

export interface IAccountSummary {
    totalUsedAmount?: number
    totalCreditAmount?: number
    totalRemainingAmount?: number
    totalDebtAmount?: number
    totalAvailableAmount?: number
    accountSummaryVo?: IAccountSummaryShop
}
export interface IAccountSummaryShop {
    totalAvailableAmount?: number
    totalCreditAmount?: number
    totalDebtAmount?: number
    totalRemainingAmount?: number
    totalUsedAmount?: number
}
export type ICustomerAccountSummary = IMdCustomerDetail & IAccountSummary

export type ISupplierAccountSummary = IMdSupplierDetail & IAccountSummary
// export interface ICustomerAccountSummary
//     extends IMdCustomerDetail, IAccountSummary {
//
// }

// export interface ISupplierAccountSummary
//     extends IMdSupplierDetail, IAccountSummary {
// }

export interface IAccountOne {
    code: string
}

export interface IAccountAdjustSubmit {
    code: string
}

export interface IAccountAdjustApproval {
    code?: string
    status?: 2 | 3 | 8
    approver?: string
    note?: string
}
export interface IAccountRechargeApproval {
    code?: string
    status?: 8 | 1 | 3
    note?: string
    approver?: string
}

export interface IAccountFields {
    code?: string
    branch?: string
    name?: string
    orgCode?: string
    orgName?: string
    beCode?: string
    beName?: string
    partnerTypeCode?: UserTypeEnum
    partnerCode?: React.Key
    partnerCodes?: string[]
    partnerName?: string
    creditFlag?: CreditFlagEnum
    categoryCode?: string
    categoryName?: string
    creditAmount?: number
    usedAmount?: number
    availableAmount?: number
    status?: AccountStatusEnum
    node?: string
    shopCode?: string
    accountTypeCode?: string // "account-type.credit"
    accountTypeName?: string // "授信账户"
    totalDebtAmount?: string | number //欠款
    remainingAmount?: string | number //剩余额度
}

export type IAccountDetail = IKey & IAccountFields & ITableRecordEdit
export type IAccountSearch = IAccountFields & ISearchPageField

export interface IAccountAdjustFields {
    branch?: string
    code?: string
    partnerTypeCode?: UserTypeEnum
    partnerCode?: Key
    partnerCodes?: string[]
    partnerName?: string
    accountCode?: string
    creditAmount?: number
    adjustAmount?: number
    status?: AdjustStatusEnum
    md5?: string
    fileName?: string
    fileSize?: number
    note?: string
    adjustTimeRange?: ITimeRangeVo
    shopCode?: string
    statusList?: string
    accountTypeCode?: string
    accountTypeName?: string
    type?: string
    creditFlag?: string
    availNodes?: AvailNode[],
    createTime?: string
}

interface AvailNode {
    "id"?: string,
    "approvalId"?: string,
    "nodeTitle"?: string,
    "nodeType"?: number,
    "approvalAmount"?: number,
    "approvalUserCode"?: string,
    "approvalUserName"?: string,
    "approvalUserDuty"?: string,
    "sort"?: number,
    "adjustStatus"?: number,
    "adjustTime"?: number[],
}

export type IAccountAdjustDetail = IKey & IAccountAdjustFields
export type IAccountAdjustSearch = IAccountAdjustFields & ISearchPageField
export type IAccountAdjustSearchParam = IAccountAdjustFields & ITimeRangeType
export interface IAccountTransactFields {
    branch?: string
    code?: string
    partnerTypeCode?: UserTypeEnum
    partnerCode?: Key
    partnerName?: string
    accountCode?: string
    creditAmount?: number
    adjustAmount?: number
    status?: TransactStatusEnum
    note?: string
    adjustTimeRange?: ITimeRangeVo
    shopCode?: string,
}

export type IAccountTransactDetail = IKey & IAccountTransactFields
export type IAccountTransactSearch = IAccountTransactFields & ISearchPageField
export type IAccountTransactSearchParam = IAccountTransactFields & ITimeRangeType

export interface IAccountRechargeFields {
    branch?: string
    code?: string
    partnerTypeCode?: UserTypeEnum
    partnerCode?: Key
    partnerCodes?: string[]
    partnerName?: string
    accountCode?: string
    accountName?: string
    remainingAmount?: number
    rechargeAmount?: number
    payMethodCode?: string
    payMethodName?: string
    operator?: string
    creditFlag?: number
    md5?: string
    fileName?: string
    fileSize?: number
    status?: RechargeStatusEnum
    note?: string
    rechargeTimeRange?: ITimeRangeVo
    shopCode?: string
    unitCode?: string
    statusList?: string
}
export interface IAccountReceivableFields {
    [key: string]: any
}
export type IAccountRechargeDetail = IKey & IAccountRechargeFields
export type IAccountRechargeSearch = IAccountRechargeFields & ISearchPageField
export type IAccountRechargeSearchParam = IAccountRechargeFields & ITimeRangeType

export type IAccountReceivableDetail = IKey & IAccountRechargeFields
export type IAccountReceivableSearch = IAccountRechargeFields & ISearchPageField
export type IAccountReceivableSearchParam = IAccountRechargeFields & ITimeRangeType
export interface IAccountTransferFields {
    branch?: string
    code?: string
    partnerTypeCode?: UserTypeEnum
    partnerOutCode?: React.Key
    partnerOutCodes?: string[]
    partnerOutName?: string
    accountOutCode?: string
    accountOutAmount?: number
    partnerInCode?: React.Key
    partnerInCodes?: string[]
    partnerInName?: string
    accountInCode?: string
    accountInAmount?: number
    transferAmount?: number
    status?: TransferStatusEnum
    note?: string
    transferTimeRange?: ITimeRangeVo
    shopCode?: string
    unitCode?: string
    inUnitCode?: string
    outUnitCode?: string
}

export type IAccountTransferDetail = IKey & IAccountTransferFields
export type IAccountTransferSearch = IAccountTransferFields & ISearchPageField
export type IAccountTransferSearchParam = IAccountTransferFields & ITimeRangeType

// 核销类型
export enum WriteoffTypeEnum {
    ONE_BILL, //"单账单核销")
    ACCOUNT, //"按账户自动核销")
    MULTI_BILL, //"多账单核销")
}
export interface IAccountWriteoffFields {
    writeoffType?: WriteoffTypeEnum
    accountCode?: string
    partnerTypeCode?: UserTypeEnum
    partnerCode?: string
    partnerCodes?: string[]
    timeAsc?: number
    mostAvailable?: number
    billCode?: string
    billCodeList?: Array<string>
    writeoffTimeRange?: ITimeRangeVo
    shopCode?: string
    [key: string]: any
}

export type IAccountWriteoffDetail = IKey & IAccountWriteoffFields
export type IAccountWriteoffSearch = IAccountWriteoffFields & ISearchPageField
export type IAccountWriteoffSearchParam = IAccountWriteoffFields & ITimeRangeType

export interface IAccountLogFields {
    branch?: string
    code?: string
    partnerTypeCode?: UserTypeEnum
    partnerCode?: React.Key
    partnerCodes?: string[]
    accountCode?: string
    logType?: AccountLogTypeEnum
    linkCode?: string
    logContent?: string
    logTime?: string
    result?: number
    operator?: string
    note?: string
    logTimeRange?: ITimeRangeVo
    shopCode?: string
}

export type IAccountLogDetail = IKey & IAccountLogFields
export type IAccountLogSearch = IAccountLogFields & ISearchPageField
export type IAccountLogSearchParam = IAccountLogFields & ITimeRangeType

export interface IAccountWriteoffFields {
    branch?: string
    code?: string
}

//账户初始化
export interface IFMSInitAccountFields {
    creditFlag?: string | number
    branch?: string
    accountTypeCode?: string
    accountTypeName?: string
    orgCode?: string
    orgName?: string
    beCode?: string
    beName?: string
    [key: string]: any
}

export interface ISCMInitCustomer {
    code: string
    name: string
}

export interface IFMSInitAccountForm {
    type: '0' | '1' //"0"是客户  ”1“ 是供应商
    fmsAccounts: IFMSInitAccountFields[]
    mdCustomers: ISCMInitCustomer[]
}

export interface IAllotAccountFields {
    branch?: string
    name?: string
    code?: string
    unitCode?: string
    unitName?: string
    shopCode?: string
    shopName?: string
    beCode?: string
    beName?: string
    creditFlag?: number
    accountTypeCode?: string
    accountTypeName?: string
    status?: number
    note?: string
}

export type IAllotAccountDetail = IKey & IAllotAccountFields
export type IAllotAccountSearch = IAllotAccountFields & ISearchPageField
export type IAllotAccountSearchParam = IAllotAccountFields & ITimeRangeType

export interface IAllotAccountWriteoffFields {
    id?: string
    branch?: string
    code?: string
    accountCode?: string
    accountName?: string
    writeoffType?: number
    timeAsc?: string
    mostAvailable?: string
    writeoffAmount?: string
    writeoffTime?: string
    status?: number
    note?: string
    beCode?: string
    beName?: string
    shopCode?: string
    shopName?: string
    unitCode?: string
    unitName?: string
    adverseUnitCode?: string
    adverseUnitName?: string
    adverseBeCode?: string
    adverseBeName?: string
    applyUser?: string
    applyTime?: string
    adverseAffirmUser?: string
    adverseAffirmTime?: string
    financeAffirmUser?: string
    financeAffirmTime?: string
    financeAuditUser?: string
    financeAuditTime?: string
    endAuditUser?: string
    endAuditTime?: string
}

export type IAllotAccountWriteoffDetail = IKey & IAllotAccountWriteoffFields
export type IAllotAccountWriteoffSearch = IAllotAccountWriteoffFields & ISearchPageField
export type IAllotAccountWriteoffSearchParam = IAllotAccountWriteoffFields & ITimeRangeType

export interface IRechargeTotalAmount {
    totalInAmount: number
    totalOutAmount: number
}

export interface IAllotAccountTransactionFields {
    id?: string
    branch?: string
    code?: string
    accountCode?: string
    accountName?: string
    writeoffType?: number
    timeAsc?: string
    mostAvailable?: string
    writeoffAmount?: string
    writeoffTime?: string
    status?: number
    note?: string
    beCode?: string
    beName?: string
    shopCode?: string
    shopName?: string
    unitCode?: string
    unitName?: string
    adverseUnitCode?: string
    adverseUnitName?: string
    adverseBeCode?: string
    adverseBeName?: string
    applyUser?: string
    applyTime?: string
    adverseAffirmUser?: string
    adverseAffirmTime?: string
    financeAffirmUser?: string
    financeAffirmTime?: string
    financeAuditUser?: string
    financeAuditTime?: string
    endAuditUser?: string
    endAuditTime?: string
}

export type IAllotAccountTransactionDetail = IKey & IAllotAccountTransactionFields
export type IAllotAccountTransactionSearch = IAllotAccountTransactionFields & ISearchPageField
export type IAllotAccountTransactionSearchParam = IAllotAccountTransactionFields & ITimeRangeType

export interface IRechargeTotalAmount {
    totalInAmount: number
    totalOutAmount: number
}

export interface IAllotAccountSummary {
    totalBillAmount?: number
    totalWriteoffAmount?: number
    totalUnWriteoffAmount?: number
    totalInvoiceAmount?: number
}
export interface IAllotSummaryAmount {
    totalUsedAmount: number // 已用
    totalCreditAmount: number //0.0,
    totalRemainingAmount: number //99924.0,
    totalDebtAmount: number //-68924.0,
    totalAvailableAmount: number //68924.0
}

/**
 * 消息类型
 */
export enum RechangeMsgEnum {
    RECHANGE, // 充值
    ADJUST, // 调额
}
/**
 * 充值消息
 */
export interface IRechangeMsgFields {
    accountCode: string
    accountName: string
    branch: string
    createTime: string
    createUser: string
    id: string
    note: string
    partnerCode: string
    partnerName: string
    partnerTypeCode: 'user-type.supplier' | 'user-type.customer'
    code: string
    shopCode: string
    shopName: string
    status: number // 0 未审核 1 已审核
    type: RechangeMsgEnum // 0 充值 1 调额
    updateTime: string
    updateUser: string
    shopCodes: string[]
}

export type IRechangeMsgDetail = Partial<IKey & IRechangeMsgFields>
export type IRechangeMsgSearch = IRechangeMsgDetail & ISearchPageField
export type IRechangeMsgSearchParam = IRechangeMsgDetail & ITimeRangeType

export interface ICustomerMergePageSearchParms {
    customerName?: string
    shopCode: string
}

export type ICustomerMergePageSearch = ICustomerMergePageSearchParms & ISearchPageField

export interface ICustomerMergeItem {
    shopCode: string
    customerCode: string
    customerName: string
    main: number
    mainId: string
    mergeNum: number
    totalCreditAmount: number
    totalRemainingAmount: number
    totalUsedAmount: number
    totalAvailableAmount: number
    totalDebtAmount: number
    id: string
}

export interface ICustomerMergeBindData {
    shopCode: string
    id?: string
    customers: { customerCode: string; main: number }[]
}

export interface IMergerCustermerInfo {
    customerCode: string
    customerName: string
    id: string
    main: number
    mainId?: string
    mergeNum?: number
    shopCode?: string
    totalAvailableAmount?: number
    totalCreditAmount?: number
    totalDebtAmount?: number
    totalRemainingAmount?: number
    totalUsedAmount?: number
}
